import template from './has-no.jade';
import hasNoOptions from '../../../../enums/has-no';

export default angular.module('cian.addForm.helperBuildingHasNo', []).directive('cianAfHelperBuildingHasNo', () => ({
  scope: {},
  bindToController: {
    ad: '=',
    form: '=',
    inputName: '@',
    modelName: '@',
    fieldName: '@',
  },
  controller(deviceService) {
    'ngInject';

    this.isMobile = deviceService.isMobile;

    this.options = hasNoOptions;
  },
  controllerAs: 'hasNo',
  template,
})).name;
